import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { ARTICLES, IMAGES } from "@/data/content";

const JournalPreview = () => (
  <section
    id="journal-preview"
    data-testid="journal-section"
    className="relative border-t border-[#27272A] py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHead
          eyebrow="The Journal"
          title="Longform ammunition. Read it, then run it."
          testId="journal-heading"
        />
        <Reveal delay={0.1}>
          <Link
            data-testid="journal-view-all-link"
            to="/journal"
            className="group flex items-center gap-2 font-jb text-xs uppercase tracking-[0.22em] text-[#CC0A14] transition-colors duration-300 hover:text-white"
          >
            All articles
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {ARTICLES.slice(0, 3).map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.1}>
            <Link
              to={`/journal/${a.slug}`}
              data-testid={`journal-card-${a.slug}`}
              className="group block border border-[#27272A] bg-[#121214] transition-colors duration-500 hover:border-[#7F1D1D]"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={IMAGES[a.image]}
                  alt={a.title}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#121214] to-transparent" />
              </div>
              <div className="p-7">
                <div className="flex items-center justify-between">
                  <span className="font-jb text-[10px] uppercase tracking-[0.22em] text-[#CC0A14]">
                    {a.category}
                  </span>
                  <span className="font-jb text-[10px] uppercase tracking-[0.22em] text-zinc-600">
                    {a.readTime}
                  </span>
                </div>
                <h3 className="mt-4 font-syne text-lg font-bold leading-snug tracking-tight text-white transition-colors duration-300 group-hover:text-[#CC0A14]">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-500">{a.excerpt}</p>
                <span className="mt-6 flex items-center gap-2 font-jb text-[11px] uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 group-hover:text-white">
                  Read article
                  <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default JournalPreview;
